import { Injectable } from '@angular/core';
import { Resolve } from '@angular/router';
import { of , Observable } from 'rxjs';
import { Event } from 'src/app/data/models/interfaces/event';
import { EventsService } from '../services/events.service';
import { map, catchError } from 'rxjs/operators';

@Injectable()
export class EventResolver implements Resolve<Event[]> {
  constructor(private service: EventsService) {}

  resolve(): Observable<any> {
    return this.service.getAll().pipe(
      map((ev) => ev),
      catchError((err) => {
        return of([])
      })
    );
  }
}
